export default __webpack_public_path__ + "static/media/Labirynth-02.7bc8de44.svg";